function detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

$('.js-search-input').each(function (k, v) {
    $(v).on('change paste keyup', function () {
        $.post('/api/search-results', {
            q: $(this).val()
        }, function (data) {
            console.log(data);
            var html = '';
            for(var i = 0; i < data.customers.length; i ++) {
                html = html + '<a class="d-block text-decoration-none btn btn-default" href="/measures/'+data.customers[i].id+'">'+data.customers[i].name+' '+data.customers[i].surname+'</a>';
            }
            $($(v).attr('data-ref')).html(html);
        });
    });
});

function checkRequired() {
    $('.js-required').each(function (k, v) {
        $(v).text($(v).text()+'*');
    });
}
checkRequired();